<!-- Page body start -->
<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <!-- Post discussion card start -->
      <div class="card">
        <div class="card-header">
          <h5>Post your nDaba here</h5>
          <span>Ask a question, post some insight or tell a story </span>
          <div class="card-header-right">
            <i class="icofont icofont-spinner-alt-5"></i>
          </div>
        </div>

        <list-errors [errors]="errors"></list-errors>

        <div class="card-block">
          <!-- Loader spinner -->
          <loader-animation
            [loading]="isSubmitting"
            [message]="'Publishing your nDaba'"
          >
          </loader-animation>
          <!-- Loader spinner -->

          <div class="j-wrapper j-wrapper-640" [hidden]="isSubmitting">
            <form
              [formGroup]="discussionForm"
              class="j-pro form-control md-float-material"
              id="j-pro"
              (keydown.enter)="$event.preventDefault()"
            >
              <div class="j-content">
                <div class="j-row">
                  <!-- community select -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">
                        <span>Community</span>

                        <span
                          class="text-danger"
                          *ngIf="
                            discussionForm.controls.community.errors?.required
                          "
                        >
                          * &nbsp;
                        </span>
                      </h5>
                    </div>

                    <div class="j-input">
                      <label class="j-icon-right" for="community">
                        <i class="icofont icofont-group"></i>
                      </label>

                      <input
                        *ngIf="editMode"
                        [disabled]="true"
                        [placeholder]="discussion.community.name"
                        type="text"
                        class="name-group"
                        (keydown.enter)="$event.preventDefault()"
                      />

                      <tag-input
                        *ngIf="!editMode"
                        theme="bootstrap"
                        [ngModel]="''"
                        [disable]="editMode"
                        [ngClass]="'tag-select'"
                        formControlName="community"
                        [maxItems]="1"
                        [placeholder]="'Enter a name of a community you follow'"
                        [onlyFromAutocomplete]="true"
                        [modelAsStrings]="true"
                        [secondaryPlaceholder]="communityPlaceholder"
                      >
                        <tag-input-dropdown
                          [showDropdownIfEmpty]="true"
                          [autocompleteItems]="userCommunities"
                          [limitItemsTo]="10"
                        >
                        </tag-input-dropdown>
                      </tag-input>
                    </div>

                    <div
                      class="messages text-danger validation-error-message"
                      *ngIf="
                        discussionForm.controls.community.errors?.required &&
                        discussionForm.controls.community.touched
                      "
                    >
                      Community can't be blank
                    </div>
                  </div>

                  <!-- community select -->

                  <!-- start title -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">
                        <span>Title</span>
                        <span
                          class="text-danger"
                          *ngIf="discussionForm.controls.title.errors?.required"
                        >
                          * &nbsp;
                        </span>
                      </h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="title">
                        <i class="icofont icofont-quill-pen"></i>
                      </label>
                      <input
                        formControlName="title"
                        type="text"
                        id="title"
                        name="title"
                        placeholder="Discussion title"
                        class="name-group"
                        (keydown.enter)="$event.preventDefault()"
                      />
                    </div>

                    <div
                      class="messages text-danger validation-error-message"
                      *ngIf="
                        discussionForm.controls.title.errors?.required &&
                        discussionForm.controls.title.touched
                      "
                    >
                      Title can't be blank
                    </div>
                  </div>
                  <!-- end title -->

                  <!-- start description -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">
                        <span>Description</span>

                        <span
                          class="text-danger"
                          *ngIf="
                            discussionForm.controls.description.errors?.required
                          "
                        >
                          * &nbsp;
                        </span>
                      </h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="description">
                        <i class="icofont icofont-question-square"></i>
                      </label>
                      <input
                        formControlName="description"
                        type="text"
                        id="description"
                        name="description"
                        placeholder="What's this discussion about?"
                        class="name-group"
                        (keydown.enter)="$event.preventDefault()"
                      />
                    </div>

                    <div
                      class="messages text-danger validation-error-message"
                      *ngIf="
                        discussionForm.controls.description.errors?.required &&
                        discussionForm.controls.description.touched
                      "
                    >
                      Description can't be blank
                    </div>
                  </div>
                  <!-- end description -->

                  <!-- start image field -->
                  <div *ngIf="discussion.slug" class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">Upload image</h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="image">
                        <i class="icofont icofont-camera"></i>
                      </label>
                      <input
                        [formControl]="discussionImageField"
                        type="text"
                        id="image"
                        name="image"
                        placeholder="URL of discussion image"
                        class="name-group"
                      />
                    </div>
                  </div>
                  <!-- end image field -->

                  <!-- start add photo -->
                  <div class="j-span12 j-unit text-center">
                    <upload-image-button
                      [targetObject]="discussion"
                      [targetType]="'Discussion'"
                      (emitImage)="saveImage($event)"
                    >
                    </upload-image-button>
                  </div>
                  <!-- end add photo -->

                  <!-- start tagList -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">
                        <span>
                          Add tags: Please add 1 or more by entering text and
                        </span>
                        <span class="text-info">pressing enter</span>
                      </h5>
                    </div>

                    <div class="j-input">
                      <label class="j-icon-right" for="tagList">
                        <i class="icofont icofont-tags"></i>
                      </label>

                      <tag-input
                        [ngModel]="discussion.tagList"
                        [ngClass]="'tag-select'"
                        theme="bootstrap"
                        [maxItems]="10"
                        formControlName="tagList"
                        [modelAsStrings]="true"
                        [editable]="true"
                        [placeholder]="'+ Add'"
                        [secondaryPlaceholder]="'Enter tags'"
                        (keydown.enter)="$event.preventDefault()"
                      >
                        <tag-input-dropdown [showDropdownIfEmpty]="true">
                        </tag-input-dropdown>
                      </tag-input>
                    </div>
                  </div>
                  <!-- end tagList -->
                </div>

                <!-- start body -->

                <div class="j-unit">
                  <div>
                    <h5 class="sub-title">
                      <span>Discussion body</span>

                      <span
                        class="text-danger"
                        *ngIf="discussionForm.controls.body.errors?.required"
                      >
                        * &nbsp;
                      </span>
                    </h5>
                  </div>
                  <div class="j-input">
                    <angular-editor
                      formControlName="body"
                      [config]="editorConfig"
                    >
                    </angular-editor>
                  </div>

                  <div
                    class="messages text-danger validation-error-message"
                    *ngIf="
                      discussionForm.controls.body.errors?.required &&
                      discussionForm.controls.body.touched
                    "
                  >
                    Body can't be blank
                  </div>
                </div>
                <!-- end body -->
              </div>
              <!-- end /.content -->
              <div class="j-footer">
                <button
                  [disabled]="!discussionForm.valid"
                  type="submit"
                  class="btn btn-primary"
                  (click)="openDiscussionPublishConfirmation()"
                >
                  <i class="icofont icofont-paper-plane"></i>
                  Publish Discussion
                </button>
              </div>
              <!-- end /.footer -->
            </form>
          </div>
        </div>
      </div>
      <!-- Post discussion card end -->
    </div>
  </div>
</div>
<!-- Page body end -->
